// TODO: remove cast once types are regenerated post-deploy
// supabase.rpc('close_bag' as any, ...) and supabase.from('bags' as any)
// use `as any` because the bags table and RPCs are not yet in auto-generated types.ts
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useTenant } from '@/hooks/useTenant';

export const useBagMutations = (bagId: string) => {
  const queryClient = useQueryClient();
  const { tenant } = useTenant();

  const close = useMutation({
    mutationFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { error } = await (supabase as any).rpc('close_bag', { p_bag_id: bagId });
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bag', tenant?.id, bagId] });
      queryClient.invalidateQueries({ queryKey: ['bags', tenant?.id] });
    },
  });

  const reopen = useMutation({
    mutationFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { error } = await (supabase as any).rpc('reopen_bag', { p_bag_id: bagId });
      if (error) {
        if (error.message.includes('already has another open bag')) {
          throw new Error('Este cliente já tem outra sacolinha aberta.');
        }
        if (error.message.includes('label generated')) {
          throw new Error('Não dá pra reabrir — a etiqueta já foi gerada.');
        }
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bag', tenant?.id, bagId] });
      queryClient.invalidateQueries({ queryKey: ['bags', tenant?.id] });
    },
  });

  const updateNotes = useMutation({
    mutationFn: async (notes: string) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { error } = await (supabase as any)
        .from('bags')
        .update({ notes })
        .eq('id', bagId);
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bag', tenant?.id, bagId] });
    },
  });

  return { close, reopen, updateNotes };
};
